import { cloneDeep } from 'lodash';
export var showBanner = function (state, action) {
    if (!state.visibleBanner) {
        var nextState = cloneDeep(state);
        nextState.visibleBanner = action.payload.bannerType;
        nextState.handlers[action.payload.bannerType] = action.payload.handlers;
        return nextState;
    }
    return state;
};
export var hideBanner = function (state, action) {
    var nextState = cloneDeep(state);
    nextState.visibleBanner = null;
    if (!nextState.dismissedBanners.includes(action.payload)) {
        nextState.dismissedBanners.push(action.payload);
    }
    return nextState;
};
